import { createSlice } from "@reduxjs/toolkit";

const cargoTypeOptions = [
  { label: "Flammable", value: "FLAMMABLE" },
  { label: "Furniture, Fixtures, and Equipment", value: "FFE" },
  { label: "IT equipment", value: "IT_EQUIPMENT" },
  { label: "Construction Materials", value: "CONSTRUCTION_MATERIALS" },
  { label: "Food and Beverage", value: "F_AND_B" },
  { label: "Waste Collection", value: "WASTE_COLLECTION" },
  { label: "Cleaning Materials", value: "CLEANING_MATERIALS" },
  { label: "Freight Delivery", value: "FREIGHT_DELIVERY" },
  { label: "Decor and Floral delivery", value: "DECOR_AND_FLORAL_DELIVERY" },
  { label: "Promo Materials", value: "PROMO_MATERIALS" },
  { label: "Others", value: "OTHERS" },
];

const vehicleTypeOptions = [
  { label: "500kg", value: "KG_500" },
  { label: "700kg", value: "KG_700" },
  { label: "1.5t", value: "T_1_5" },
  { label: "3t", value: "T_3" },
  { label: "5t", value: "T_5" },
  { label: "7t", value: "T_7" },
];

const deliveryZoneOptions = [
  { label: "Green", value: "GREEN" },
  { label: "Blue", value: "BLUE" },
];

const deliveryTypeOptions = [
  { label: "Delivery", value: "DELIVERY" },
  { label: "Collection", value: "COLLECTION" },
  { label: "Delivery&Collection", value: "DELIVERYCOLLECTION" },
];

const optionsSlice = createSlice({
  name: "optionsSlice",
  initialState: {
    cargoTypeOptions,
    deliveryZoneOptions,
    deliveryTypeOptions,
    vehicleTypeOptions,
  },
  reducers: {
    populateData(state, action) {
      state.items = action.payload;
    },
  },
});

export const sliceActions = optionsSlice.actions;

export default optionsSlice.reducer;
